const getDefaultState = () => ({
  xmlChannels: {
    items: [],
    loading: false,
    error: undefined,
    xmlChannel: undefined,
  },
  addons: {
    items: [],
    loading: false,
    error: undefined,
    update: {
      inProgressItems: {},
      errorItems: {},
    },
    search: undefined,
    addon: {
      id: undefined,
      description: undefined,
      showProductNames: false,
      productNames: [],
    },
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/ski/restech/defaultState.js